import * as Types from '../../../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type FindInviteQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  firstName?: Types.InputMaybe<Types.Scalars['String']>;
  lastName?: Types.InputMaybe<Types.Scalars['String']>;
  email?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type FindInviteQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    activeSession: { __typename?: 'EventSession'; id: string; sessionId: string };
    findPeople: {
      __typename?: 'PeopleFindResultSet';
      resultCount: number;
      results: Array<{
        __typename?: 'PeopleFindResult';
        person: { __typename?: 'Person'; id: string; personIdTag: string; firstName?: string | null; lastName?: string | null; email?: string | null };
      }>;
    };
  } | null;
};

export const FindInviteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FindInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeSession' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'findPeople' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'criteria' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          { kind: 'ObjectField', name: { kind: 'Name', value: 'firstName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } } },
                          { kind: 'ObjectField', name: { kind: 'Name', value: 'lastName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } } },
                          { kind: 'ObjectField', name: { kind: 'Name', value: 'email' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } } },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'options' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          { kind: 'ObjectField', name: { kind: 'Name', value: 'allGuestStates' }, value: { kind: 'BooleanValue', value: true } },
                          { kind: 'ObjectField', name: { kind: 'Name', value: 'strategy' }, value: { kind: 'EnumValue', value: 'myInvite' } },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'resultCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'results' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'person' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'personIdTag' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFindInviteQuery__
 *
 * To run a query within a React component, call `useFindInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindInviteQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useFindInviteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindInviteQuery, FindInviteQueryVariables>) {
  return ApolloReactHooks.useQuery<FindInviteQuery, FindInviteQueryVariables>(FindInviteDocument, baseOptions);
}
export function useFindInviteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindInviteQuery, FindInviteQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<FindInviteQuery, FindInviteQueryVariables>(FindInviteDocument, baseOptions);
}
export type FindInviteQueryHookResult = ReturnType<typeof useFindInviteQuery>;
export type FindInviteLazyQueryHookResult = ReturnType<typeof useFindInviteLazyQuery>;
export type FindInviteQueryResult = Apollo.QueryResult<FindInviteQuery, FindInviteQueryVariables>;
